import React from 'react'

const Simple = ({field, values}) => {
  return (
    <div className="bg-[#F2F2F2] p-2 rounded font-bold">
    <p>R: {values[field.id] ?? field.chosen}</p>
   </div>
  )
}

export default Simple